import { NotLoggedInError, NotLoggedInToWorkspaceError, NotLoggedInWithGuestLinkError, } from '@lucidlink/sdk';
import { BadRequestError, ForbiddenError, ServiceUnavailableError, UnauthorizedError, } from '@lucidlink/sdk/fetcher';
import { DEFAULT_QUERY_RETRY } from './constants';
// Error classes that should never be retried by React Query.
export const NON_RETRYABLE_ERRORS = [
    BadRequestError,
    ForbiddenError,
    NotLoggedInError,
    NotLoggedInToWorkspaceError,
    NotLoggedInWithGuestLinkError,
    ServiceUnavailableError,
    UnauthorizedError,
];
export function queryRetry(failureCount, error) {
    if (NON_RETRYABLE_ERRORS.some((errorClass) => error instanceof errorClass)) {
        return false;
    }
    return failureCount < DEFAULT_QUERY_RETRY;
}
export function createDefaultQueryClientOptions() {
    return {
        queries: {
            retry: queryRetry,
        },
    };
}
